const env = import.meta.env;

export const config = {
  apiUrl: (env.VITE_API_URL as string | undefined)?.replace(/\/$/, "") || "/api",
  cognito: {
    userPoolId: (env.VITE_COGNITO_USER_POOL_ID as string | undefined) ?? "",
    clientId: (env.VITE_COGNITO_CLIENT_ID as string | undefined) ?? "",
    domain: (env.VITE_COGNITO_DOMAIN as string | undefined)?.replace(/\/$/, "") ?? "",
    region: (env.VITE_AWS_REGION as string | undefined) ?? "ap-southeast-2",
  },
  realtime: {
    endpoint: (env.VITE_REALTIME_ENDPOINT as string | undefined) ?? "",
    authorizer: (env.VITE_REALTIME_AUTHORIZER as string | undefined) ?? "",
    topicPrefix: (env.VITE_REALTIME_TOPIC_PREFIX as string | undefined) ?? "skynet/dev",
  },
  /** Local development without Cognito (the API must run with SKYNET_AUTH_DISABLED=1). */
  authDisabled: env.VITE_AUTH_DISABLED === "1" || !(env.VITE_COGNITO_CLIENT_ID as string | undefined),
  pollIntervalMs: Number(env.VITE_POLL_INTERVAL_MS ?? 8000),
};

export const authority = config.cognito.userPoolId
  ? `https://cognito-idp.${config.cognito.region}.amazonaws.com/${config.cognito.userPoolId}`
  : "";
